module.exports = __webpack_public_path__ + "static/media/AWS-Certified-Cloud-Practitioner_badge.25ede0a6.png";